import {
  SET_SELECTED_UNIT_WIZARD,
  SET_WIZARD_INITIALIZED,
} from "actions/wizard";

const initialState = {
  loading: false,
  selectedUnit: null,
  initialized: false,
};

export default function wizard(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SET_SELECTED_UNIT_WIZARD: {
      return {
        ...state,
        selectedUnit: payload,
      };
    }

    case SET_WIZARD_INITIALIZED: {
      return {
        ...state,
        initialized: payload,
      };
    }

    default:
      return state;
  }
}
